// extracted by mini-css-extract-plugin
export default {"tile":"BO2MFfGITKvoWps1v8vF","heading":"upw5GEQ5mKZzyEJcqfiT","info":"LDglen3pJltbBdbPC_d1","name":"ZEh0xpO4scy9bWwDy3Iz","partial":"lYIqrWsVUbQtdRWHxTM_"};